import { useSelectSlice } from "@common/redux/selectors/useSelectSlice";
import { streamsSlice } from "@common/redux/slices/entities.slice";
import { IStream } from "@common/redux/types/stream";
import { EntitiesGrid } from "@kursk/components/ui/EntitiesGrid/EntitiesGrid";
import { StreamCard } from "../StreamCard/StreamCard";
import { useOrientations } from "@common/hooks/useOrientation";
import styles from "./StreamsGrid.module.scss";

export function StreamsGrid() {
  const { items, total, offset } = useSelectSlice(streamsSlice);
  const orientation = useOrientations();

  return (
    <EntitiesGrid
      <IStream>
      entityType="streams"
      items={items}
      total={total}
      offset={offset}
      renderGridCard={(item: IStream) => <StreamCard key={item._id} stream={item} orientation={orientation} />}
      customStyle={styles}
    />
  );
}
